import { ApiClient } from '../../ApiClient';
class ProductsApiClient {
    constructor() {
        this.apiClient = new ApiClient('/api/products');
    }
    async getFavoriteProducts() {
        return await this.apiClient.get('/favorites');
    }
}
const productsApiClient = new ProductsApiClient();
export default productsApiClient;
